import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { HeaderWidget, HeaderWidgetComponent } from 'app/views/presentations/widgets/header/header.widget';
import { WidgetWrapperModule } from 'app/views/presentations/widgets/widgetWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        WidgetWrapperModule.wrapWidget(HeaderWidget)
    ],
    declarations: [
        HeaderWidgetComponent
    ],
    entryComponents: [
        HeaderWidgetComponent
    ]
})
export class HeaderWidgetModule { }



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/header/header.module.ts